export default __webpack_public_path__ + "web/images/exit (2).svg";